import { initChart } from "./stats.js";

window.addEventListener("load", function () {
  initChart("public", "media-type-distribution", true);
});
